<template>
	<roi-container>
		<template slot="header">
			Calculate Savings
		</template>
		<template slot="content">

			<v-layout row mt-4>
				<v-flex class="white--text subheading">
					How many analyst hours are used each month for collecting data, preparing it and running reports?
				</v-flex>
			</v-layout>
			<v-layout row mt-4>
				<v-flex>
					<v-slider
					color="primary darken-3"
					class="ma-0"
					v-model="analyst.slider"
					thumb-color="white"
					track-color="primary lighten-2"
					:max="dynamicMax(analyst.slider, 20)"
					:min="analyst.min"
					></v-slider>
				</v-flex>
				<v-flex
					shrink
					style="font-size:1.3em;width:85px;text-align:right;white-space:nowrap"
					class="white--text font-weight-bold ml-3"
					v-html="totalAnalystHours + ' hours'"/>
			</v-layout>

			<v-divider/>

			<v-layout row mt-4>
				<v-flex class="white--text subheading">
					How many hours are spent each month for testing and sending out reports to users?
				</v-flex>
			</v-layout>
			<v-layout row mt-4>
				<v-flex>
					<v-slider
					color="primary darken-3"
					class="ma-0"
					v-model="reports.slider"
					thumb-color="white"
					track-color="primary lighten-2"
					:max="dynamicMax(reports.slider, 20)"
					:min="reports.min"
					></v-slider>
				</v-flex>
				<v-flex
					shrink
					style="font-size:1.3em;width:85px;text-align:right;white-space:nowrap"
					class="white--text font-weight-bold ml-3"
					v-html="totalReportsHours + ' hours'"/>
			</v-layout>

			<v-divider/>

			<v-layout row mt-4>
				<v-flex class="white--text subheading">
					Average analyst hourly wage?
				</v-flex>
				<v-flex
					shrink
					style="font-size:1.3em;width:85px;text-align:right;white-space:nowrap"
					class="white--text font-weight-bold"
					v-html="totalLabor"/>
			</v-layout>

			<v-layout row>
				<v-slider
				color="primary darken-3"
				class="ma-0"
				v-model="labor.slider"
				thumb-color="white"
				track-color="primary lighten-2"
				:max="dynamicMax(labor.slider, 17)"
				:min="labor.min"
				></v-slider>
			</v-layout>
			
			<!-- <v-layout align-center justify-center row mb-4>
				<v-btn-toggle
					class="transparent"
					v-model="labor.multiplier">
					<v-btn :value="1" flat small ripple class="btn-group">$10-$1k</v-btn>
					<v-btn :value="10" flat small ripple class="btn-group">$1k-$10k</v-btn>
					<v-btn :value="100" flat small ripple class="btn-group">$10k+</v-btn>
				</v-btn-toggle>
			</v-layout> -->

		</template>

		<template slot="button">
			<v-layout row mt-4 align-center justify-center>
				<v-btn @click="seeResults()" color="primary darken-2" ripple large>View Results</v-btn>
			</v-layout>
		</template>

	</roi-container>
</template>

<script>
import RoiContainer from './RoiContainer.vue'

export default {
	components: {
		RoiContainer
	},
	props: {
		data: {
			type: [Object],
			default: () => {}
		},

	},
	data() {
		return {
			labor: {
				min: 1,
				slider: 19,
				multiplier: 1,
			},
			analyst: {
				min: 1,
				slider: 35,
			},
			reports: {
				min: 1,
				slider: 25,
			}
		}
	},
	created() {
		this.labor.slider = this.data.labor ? this.data.labor : this.labor.slider
		this.reports.slider = this.data.reports ? this.data.reports : this.reports.slider
		this.analyst.slider = this.data.analyst ? this.data.analyst : this.analyst.slider
	},
	computed: {
		totalLabor() {
			return this.$parent.formatter.format(this.totalLaborRaw)
		},
		totalLaborRaw() {
			return this.labor.multiplier * this.labor.slider
		},
		totalAnalystHours() {
			return this.analyst.slider
		},
		totalReportsHours() {
			return this.reports.slider
		},
		calculated() {
			return this.totalLaborRaw * (this.totalReportsHours + this.totalAnalystHours) * 0.8
		}
	},
	methods: {
		dynamicMax(current, multiplier = 50) {
			return (current + multiplier) < 2000 ? (current + multiplier) : 2000
		},
		seeResults() {
			this.$parent.component = 'RoiResults'
			this.$parent.savings = this.calculated
			this.$parent.data = {
				labor: this.labor.slider,
				reports: this.reports.slider,
				analyst: this.analyst.slider,
			}
		}
	}
}
</script>
<style>
@media(max-width: 768px) {
	.v-slider__thumb {
		width: 40px!important;
		height: 40px!important;
	}
}
</style>
